'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { CodeStore } from './code'
import {
  createCodeActions,
  defaultValues,
  selectSelectedConfigurations,
  selectSelectedFieldUsageCode,
  selectSelectedImportCode,
  selectSelectedInstanceCode,
  selectSelectedSetupCommands,
  selectSelectedUsageCode,
  selectSelectedVariableCode,
} from './code'

export const useCodeStore = create<CodeStore>()(
  devtools(
    (set) => ({
      ...defaultValues,
      ...createCodeActions(set),
    }),
    { name: 'CodeStore' }
  )
)

// Re-export selectors for convenience
export {
  selectSelectedConfigurations,
  selectSelectedFieldUsageCode,
  selectSelectedImportCode,
  selectSelectedInstanceCode,
  selectSelectedSetupCommands,
  selectSelectedUsageCode,
  selectSelectedVariableCode,
}
